import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from '../Logo';
import './styles.less';

const AppstoreButton = (props) => {
    return (
        <div
            className={classNames('p-appstore-button', ({[`p-appstore-button--${props.alignment}`]: true}))}
            data-cid={props.contentId}
        >
            <a href={props.url} className="p-appstore-button__link" target={props.openInNewTab ? '_blank' : '_self'}>
                <Logo
                    logoSet="appstore"
                    className="p-appstore-button__logo"
                    size={props.size}
                    id={props.id}
                    sprite={false}
                    aspectRatio=""
                />
            </a>
        </div>
    );
};

AppstoreButton.propTypes = {
    id: PropTypes.oneOf(['Apple', 'apple', 'Amazon', 'amazon', 'Google', 'google']).isRequired,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    contentId: PropTypes.string,
    alignment: PropTypes.oneOf(['Left', 'left', 'Center', 'center', 'Right', 'right']),
    openInNewTab: PropTypes.bool,
    url: PropTypes.string
};

AppstoreButton.defaultProps = {
    size: undefined,
    contentId: undefined,
    alignment: undefined,
    openInNewTab: false,
    url: undefined
};

export default AppstoreButton;
